module.exports = __webpack_public_path__ + "static/img/banner_h5_02_zh.5f23eea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_h5_02_zh.png
// module id = uD1I
// module chunks = 34